import { IPicture } from '../../../../../model/shared/IPicture';
import { ICompany } from '../../../../shared/user/dto/ICompany';
import { User } from '../../../../../model/user/User';

export interface ICreateCampaign {
    info: IInfo;
    hasSuppliers: boolean;
    hasClients: boolean;
}

export interface ICampaignGoals {
    id: number;
    createdAt?: string;
    updatedAt?: string;
    title: string;
    story: string;
    storyGerman: string;
    isActive: boolean;
    goalImage: IPicture;
    isSelected?: boolean;
    summary?: string;
}

export interface IInfo {
    id: number;
    userReviewRating: number;
    company: ICompany;
    title: string;
    url: string;
    publishFrom: string;
    publishTo: string;
    package: string;
    netBudget: number;
    campaignImages: IPicture[];
    campaignGoal: ICampaignGoals;
}

export interface ICreateCampaignRequest {
    title: string;
    campaignSharingType?: string;
    isLongTerm: boolean;
    partner?: User;
    parentId?: number;
}

export const createCampaignInitialData: ICreateCampaignRequest = {
    title: '',
    campaignSharingType: 'own_management',
    isLongTerm: false,
};

export interface IEditCampaignModalProps {
    isEdit: boolean;
    isContractType?: boolean;
}
